<template>
  <nav class="navbar navbar-expand">
    <div class="container-fluid">
      <!-- Left: Logo/menu -->
      <div class="navbar-left">
        <div
            class="menu-icon clickable"
            @click="toggleSidebar()"
            v-if="isMobile"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 16 16" aria-label="Меню" role="img" class="IconSVG IconSVG_type_game-menu-white"><path fill="#fff" fill-rule="evenodd" d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H1Z" clip-rule="evenodd"></path></svg>
        </div>
        <img
            alt="cleverapps"
            class="navbar-brand"
            :src="require('./../../assets/logo.png')"
            @click="gotoGames()"
        >
      </div>
      <div class="navbar-center">
        <slot name="center"></slot>
      </div>
      <div class="navbar-right">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="navbar-mobile-row">
        <slot name="mobile-row"></slot>
    </div>
  </nav>
</template>

<script>
import portalData from "./../../portal.json";

export default {
  name: "NavBar",
  data() {
    return {
      screenWidth: 1000,
      portalData: portalData,
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    setTimeout(() => { this.onResize(); }, 500);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    lang() {
      return this.language;
    },
    isMobile() {
      return this.screenWidth <= 760;
    }
  },
  methods: {
    gotoGames() {
      this.$router.push({
        name: "Games",
        params: { category: "games" },
      });
    },
    toggleSidebar() {
      this.$emit("onToggleSidebar");
    },
    onResize() {
      this.screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
    },
  },
};
</script>

<style scoped>
.navbar{
  background-color: var(--primary-background-color);
  display: flex;
  flex-direction: column;
}
.container-fluid {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 40px;
}

.navbar-left {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.navbar-center {
  flex: 1 1 0%;
  display: flex;
  justify-content: center;
}

.navbar-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
}

.navbar-brand {
  height: 40px;
  cursor: pointer;
  padding: 10px 0;
}

.navbar-mobile-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-icon {
  height: 24px;
  width: 24px;
}
</style>
